import React from "react";
import { getSEOData } from "../../../../global/utils/constants/seoConfig";
import SEO from "../../../../global/components/SEO/SEO";
import { MobileContent } from "../Components/MobileContent";

const MobileApp = () => {
  const seoData = getSEOData("/mobile-applications");

  return (
    <>
      <SEO
        title={seoData.title}
        description={seoData.description}
        keywords={seoData.keywords}
        type="website"
      />
      <MobileContent />
    </>
  );
};

export default MobileApp;